import "./HeadingWithNavigationComponent.scss";
import {useCallback} from "react";
import IconButtonComponent from "../icon-button/IconButtonComponent";
import {ImageConfig} from "../../../constants";

interface HeadingWithNavigationComponentProps {
    title: string;
    onBackNavigation: Function;
}

const HeadingWithNavigationComponent = (props: HeadingWithNavigationComponentProps) => {
    const {title, onBackNavigation} = props;

    const handleBackClick = useCallback(() => {
        if (onBackNavigation) {
            onBackNavigation();
        }
    }, [onBackNavigation]);

    return (
        <div className={'heading-with-navigation-component'}>
            <div className="back-navigation-wrapper" onClick={handleBackClick}>
                <div className="back_navigation">
                    <IconButtonComponent className="navigation_icon">
                        <ImageConfig.LeftArrow/>
                    </IconButtonComponent>
                </div>
                <div className="title">{title}</div>
            </div>

        </div>
    );

};

export default HeadingWithNavigationComponent;